export interface OpenWorkerDetailPanelInput {
  workerAccountId: string
  trustedAccountId: string
  viewerAccountId?: string
}

const listeners: ((input: OpenWorkerDetailPanelInput) => void)[] = []

export function addOpenWorkerDetailPanelListener(
  listener: (input: OpenWorkerDetailPanelInput) => void,
) {
  listeners.push(listener)
}

export function openWorkerDetailPanel(input: OpenWorkerDetailPanelInput) {
  for (const listener of listeners) {
    listener(input)
  }
}
